import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { updatePpwrPackingTypeWeightRequest } from 'redux/reducers/ppwr/reducer';
import { TPpwrPackingType } from 'redux/reducers/ppwr/types';
import { PpwrEditValueDialog } from '../../PpwrEditValueDialog';

type TEditWeightDialogProps = {
	rows: TPpwrPackingType[];
	index: number | null;
	setIndex: (index: number) => void;
	onClose: () => void;
};

// Empty clears the weight, otherwise a non-negative number (decimals allowed).
const isValidWeight = (value: string) =>
	value.trim() === '' || /^\d+([.,]\d+)?$/.test(value.trim());

const toWeight = (value: string) => (value === '' ? null : Number(value.replace(',', '.')));

const toInitialValue = (value: number | null | undefined) =>
	value !== null && value !== undefined ? String(value) : '';

export const EditWeightDialog: FC<TEditWeightDialogProps> = ({
	rows,
	index,
	setIndex,
	onClose,
}) => {
	const dispatch = useDispatch();
	const row = index !== null ? rows[index] : null;

	const handleSave = ([weight, weightProductPack]: string[]) => {
		if (!row) return;
		dispatch(
			updatePpwrPackingTypeWeightRequest({
				packingTypeId: row.id,
				weight: toWeight(weight),
				weightProductPack: toWeight(weightProductPack),
			}),
		);
	};

	return (
		<PpwrEditValueDialog
			rowsCount={rows.length}
			index={row ? index : null}
			setIndex={setIndex}
			onClose={onClose}
			title={row?.name ?? ''}
			fields={[
				{
					label: 'Weight, grams',
					initialValue: toInitialValue(row?.weight),
					isValid: isValidWeight,
					invalidText: 'Enter a number, 0 or more',
				},
				{
					label: 'Product Pack Weight, grams',
					initialValue: toInitialValue(row?.weightProductPack),
					isValid: isValidWeight,
					invalidText: 'Enter a number, 0 or more',
				},
			]}
			onSave={handleSave}
		/>
	);
};
